import type { ColDef } from "ag-grid-community";

export const useTableData = () => {
  const columnDefs: ColDef[] = [
    {
      headerName: "Part Type",
      field: "PartTypeName",
      flex: 1,
      sortable: true,
      filter: true,
      resizable: true,
    },
  ];

  return { columnDefs };
};
